import React, { useRef } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/router'
import * as S from './SectionModulosBioAtlas.styles'
import ImageNext from '@/components/ImageNext'
import { PAGE_PATHS } from '@/services/paths'

const MODULOS = [
  {
    nome: 'Histologia',
    img: 'histologia.png',
    key: 'histologia',
    href: PAGE_PATHS.contentsPages.histology
  },
  {
    nome: 'Patologia',
    img: 'patologia.png',
    key: 'patologia',
    href: PAGE_PATHS.contentsPages.pathology
  },
  {
    nome: 'Histopatologia',
    img: 'histopatologia.png',
    key: 'histopatologia',
    href: PAGE_PATHS.contentsPages.histopathology
  },
  {
    nome: 'Radiologia',
    img: 'radiologia.png',
    key: 'radiologia',
    href: PAGE_PATHS.contentsPages.radiology
  },
  {
    nome: 'Fisiologia',
    img: 'fisiologia.png',
    key: 'fisiologia',
    href: PAGE_PATHS.contentsPages.physiology
  },
  {
    nome: 'Embriologia',
    img: 'embriologia.png',
    key: 'embriologia',
    href: PAGE_PATHS.contentsPages.embryology
  },
  {
    nome: 'Citologia',
    img: 'citologia.png',
    key: 'citologia',
    href: PAGE_PATHS.contentsPages.cytology
  },
  {
    nome: 'Anatomia Topográfica',
    img: 'anatomia-topografica.png',
    key: 'anatomiaTopografica',
    href: PAGE_PATHS.contentsPages.topographicAnatomy
  },
  {
    nome: 'Anatomia Sistêmica',
    img: 'anatomia-sistemica.png',
    key: 'anatomiaSistemica',
    href: PAGE_PATHS.contentsPages.systemicAnatomy
  },
  {
    nome: 'Anatomia Completa',
    img: 'anatomia-completa.png',
    key: 'anatomiaCompleta',
    href: PAGE_PATHS.contentsPages.completeAnatomy
  }
]

const settings = {
  arrows: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000,
  slidesToShow: 5.2, // 5 inteiros + 6º parcialmente visível
  slidesToScroll: 1,
  infinite: true,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 4 } },
    { breakpoint: 900, settings: { slidesToShow: 3 } },
    { breakpoint: 600, settings: { slidesToShow: 2 } }
  ]
}

const SectionModulosBioAtlas = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const sliderRef = useRef<Slider | null>(null)

  const handleItemMouseEnter = () => {
    sliderRef.current?.slickPause()
  }

  const handleItemMouseLeave = () => {
    sliderRef.current?.slickPlay()
  }

  return (
    <S.Section>
      <S.Title>{t('landingV2.sectionModulosBioAtlas.title')}</S.Title>
      <S.CarouselWrapper>
        <Slider ref={sliderRef} {...settings}>
          {MODULOS.map((modulo, idx) => (
            <S.Item
              key={modulo.key}
              onMouseEnter={handleItemMouseEnter}
              onMouseLeave={handleItemMouseLeave}
            >
              <S.ItemTitle>
                {t(`landingV2.sectionModulosBioAtlas.modules.${modulo.key}`)}
              </S.ItemTitle>
              <S.ItemImageWrapper>
                {modulo.img ? (
                  <ImageNext
                    src={`${process.env.CDN_URL}/public/landingpagev2/images/modulos/${modulo.img}`}
                    alt={t(
                      `landingV2.sectionModulosBioAtlas.modules.${modulo.key}`
                    )}
                    width={modulo.nome === 'Histopatologia' ? 120 : 160}
                    height={modulo.nome === 'Histopatologia' ? 120 : 160}
                    style={{ maxWidth: '100%', height: 'auto', width: 'auto' }}
                    priority={idx < 6}
                    className="modulo-img"
                  />
                ) : (
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      background: '#eee',
                      borderRadius: 12,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#bbb',
                      fontSize: 14
                    }}
                  >
                    {t('landingV2.sectionModulosBioAtlas.fallbackText')}
                  </div>
                )}
              </S.ItemImageWrapper>
              <S.HoverOverlay className="hover-overlay">
                <S.HoverButton onClick={() => router.push(modulo.href)}>
                  {t('landingV2.sectionModulosBioAtlas.knowMore', 'Saber mais')}
                </S.HoverButton>
              </S.HoverOverlay>
            </S.Item>
          ))}
        </Slider>
      </S.CarouselWrapper>
      <style>{`
        @media (max-width: 600px) {
          .modulo-img {
            width: 80px !important;
            height: auto !important;
            display: block;
            margin: 0 auto;
          }
        }
      `}</style>
    </S.Section>
  )
}

export default SectionModulosBioAtlas
